module.exports = __webpack_public_path__ + "images/emoji/credit_card.a5aa10bff88310514bc8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/credit_card.png
// module id = go32
// module chunks = 2